import { memo } from 'react';

import type { LbPostData } from '../../types';
import { LbEventPhase } from '../../types';
import { time } from '../../utils';

const Header = ({ liveblogPostData, date }: { liveblogPostData: LbPostData; date: string }) => (
  <div
    className={`lb-post-time ${
      liveblogPostData?.lbPostFSPEvent?.eventPhase === LbEventPhase.PENALTY ? 'lb-penalty-phase' : ''
    }`}
  >
    <span className='lb-time-post'>{time(date)}</span>
    <span className='lb-minute-post'>{liveblogPostData?.lbPostFSPEvent?.eventDisplayMinute}</span>
  </div>
);

export default memo(Header);
